import { FC, useState, useEffect } from "react";
import {
  ResponsiveContainer,
  BarChart as RechartBarChart,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from "recharts";
import { Box, Typography, useTheme } from "@mui/material";
import { Chart } from "../types"; // Adjust import path as needed
import { getAxios } from "../../../../utils/endpoints";

export const BarChart: FC<Chart> = (props) => {
  const [sources, setSources] = useState([]);

  const theme = useTheme();

  const barHeight: number = 80;
  const maxVisibleBars: number = 12;
  const calculatedHeight = Math.min(
    props.chartData.length * barHeight,
    maxVisibleBars * barHeight
  );

  if (!props?.chartData || props.chartData.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No data available.
      </Typography>
    );
  }

  return (
    <Box sx={{ width: "100%", minHeight: 200 }}>
      <ResponsiveContainer width="100%" height={calculatedHeight}>
        <RechartBarChart layout="vertical" data={props.chartData}>
          <XAxis
            type="number"
            tick={{ fill: theme.palette.text.secondary }}
            axisLine={{ stroke: theme.palette.divider }}
          />
          <YAxis
            type="category"
            dataKey="labelName"
            width={150}
            tick={{ fill: theme.palette.text.primary }}
            interval={0}
            axisLine={{ stroke: theme.palette.divider }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: theme.palette.background.paper,
              borderColor: theme.palette.divider,
              borderRadius: 6,
              boxShadow: theme.shadows[2],
            }}
          />
          <Bar dataKey="dataValue1" fill={theme.palette.primary.main} />
        </RechartBarChart>
      </ResponsiveContainer>
    </Box>
  );
};
